import IntlContainer from './IntlContainer'

export default IntlContainer
